import {
	deriveDeterministicSeed32,
	expandDeterministicSeed,
	seedKeyGen,
} from "@filosign/crypto-utils";
import type { FilosignContracts } from "@filosign/evm";
import type { FilosignContextValue } from "../../context/FilosignContext";
import type { FilosignWallet } from "../../lib/wallet";
import type { StoredKeygenData } from "./key-registry-snapshot";

type Wallet = FilosignWallet;

export async function unlockSeedFromWallet(args: {
	wallet: Wallet;
	contracts: FilosignContracts;
	wasm: FilosignContextValue["wasm"];
	storedKeygenData?: StoredKeygenData;
}): Promise<Uint8Array | null> {
	const { wallet, wasm } = args;

	try {
		const stored = args.storedKeygenData;
		if (!stored) {
			return null;
		}

		const { saltSeed, saltChallenge, commitmentKem, commitmentSig } = stored;

		const seedCore32 = await deriveDeterministicSeed32(wallet, {
			saltChallenge,
			saltSeed,
		});
		const seed = await expandDeterministicSeed(seedCore32);
		const dilithium = wasm.dilithium;
		if (!dilithium) return null;
		const keygenData = await seedKeyGen(new Uint8Array(Array.from(seed)), {
			dl: dilithium,
		});

		if (
			commitmentKem !== keygenData.commitmentKem ||
			commitmentSig !== keygenData.commitmentSig
		) {
			return null;
		}

		return seed;
	} catch {
		return null;
	}
}
